import AppModal from '@/components/atoms/AppModal';
import { AppButton } from '@/components/atoms';
import RezeptSheetFormFields from '@/components/molecules/RezeptSheetFormFields';
import { useCreateRezeptSheet } from '@/hooks/admin/useCreateRezeptSheet';
import { createRezeptSheetSchema, type CreateRezeptSheetFormData } from '@/schemas/rezeptSheetSchema';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTrimmedForm } from '@/shared/lib/useTrimmedForm';

interface CreateRezeptSheetModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CreateRezeptSheetModal = ({ isOpen, onClose }: CreateRezeptSheetModalProps) => {
  const { createRezeptSheet, isPending } = useCreateRezeptSheet();

  const {
    handleSubmit,
    reset,
    control,
    clearErrors,
    formState: { errors },
  } = useTrimmedForm<CreateRezeptSheetFormData>({
    resolver: zodResolver(createRezeptSheetSchema),
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    defaultValues: {
      service_type: '',
      sheet_name: '',
      unit_amount: '',
      price: '',
      sortno: '',
      available_from: '',
      available_to: '',
    },
  });

  const handleClose = () => {
    reset();
    onClose();
  };

  const onSubmit = async (data: CreateRezeptSheetFormData) => {
    await createRezeptSheet({
      ...data,
      available_to: data.available_to || null,
    });
    handleClose();
  };

  return (
    <AppModal
      isOpen={isOpen}
      onClose={handleClose}
      title="レセプト用紙作成"
      maxWidth="max-w-lg"
      footer={null}
    >
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <RezeptSheetFormFields errors={errors} control={control} clearErrors={clearErrors} />

        <div className="flex justify-end gap-2 pt-2">
          {/* <AppButton onClick={handleClose}>キャンセル</AppButton> */}
          <AppButton type="primary" htmlType="submit" loading={isPending}>
            更新
          </AppButton>
        </div>
      </form>
    </AppModal>
  );
};

export default CreateRezeptSheetModal;
